import { Injectable, Type } from '@angular/core';
import { ActividadNegocioDialogComponent } from 'src/app/shared/components/actividad-negocio-dialog/actividad-negocio-dialog.component';
import { AsesorDialogComponent } from 'src/app/shared/components/asesor-dialog/asesor-dialog.component';
import { BankDialogComponent } from 'src/app/shared/components/bank-dialog/bank-dialog.component';
import { CiudadDialogComponent } from 'src/app/shared/components/ciudad/ciudad-dialog.component';
import { ProvinciaDialogComponent } from 'src/app/shared/components/provincia-dialog/provincia-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DataSetComponentService {
  COMPONENTS: any = {
    "ActividadNegocioDialogComponent": ActividadNegocioDialogComponent,
    "BankDialogComponent": BankDialogComponent,
    "AsesorDialogComponent": AsesorDialogComponent,
    "ProvinciaDialogComponent": ProvinciaDialogComponent,
    "CiudadDialogComponent": CiudadDialogComponent
  }

  get(name: string): any {
    return this.COMPONENTS[name];
  }
}
